import { useEffect } from 'react';
import { userActions } from 'src/actions.js';

export default function LogoutComponent(props) {
	useEffect(() => {
		const asyncSignOut = async () => {
			const { signOut } = userActions;
			signOut();
			// This handleSignOut comes from Api Provider -> app component -> app router -> logout component
			// To prevent race conditions, don't call handleSignOut from other components, a redirect to /logout is all that's needed
			await props.handleSignOut();
			props.history.push('/');
		};

		asyncSignOut();
	}, []);

	return <></>; // The ApiProvider will render a spinner, this component has no rendering
}
